<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a class="btn btn-dark btn-sm btn-new" [routerLink]="['/marketing']">
            Keywords
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPageCampaigns/urlMapping']"
          >
            URL Mapping
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/onPage']"
          >
            On-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/internalLinks/add']"
          >
            Internal Links
          </a>
        </div>
      </div>
    </div>

    <div class="row pb-3">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a class="btn btn-dark btn-sm btn-reg"> Technical QA </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/localSeo']"
          >
            Local SEO
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPage']"
          >
            Off-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/performance']"
          >
            Performance
          </a>
        </div>
      </div>
    </div>
    <div class="url-mapping-container p-4" *ngIf="!loading">
      <!-- ── HEADER ─────────────────────────────────────────────────────── -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div class="d-flex align-items-center gap-3">
          <div class="header-icon bg-success text-white rounded p-2">
            <i class="fas fa-shield-alt fa-lg"></i>
          </div>
          <div class="pl-2">
            <h2 class="h4 mb-0 fw-bold">TECHNICAL QA</h2>
            <!-- <p class="text-muted mb-0 small">
              Ensure URLs are crawlable, indexable, and technically healthy for
              optimal SEO performance.
            </p> -->
          </div>
        </div>
        <div class="d-flex gap-2">
          <!-- <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-play-circle me-1"></i> How it works
          </button> -->
          <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-download me-1"></i> Export Report
          </button>
          <!-- <button class="btn btn-dark btn-sm btn-add p-1 btn-header">
            <i class="fas fa-plus me-1"></i> New Technical Review
          </button> -->
        </div>
      </div>

      <!-- ── MAIN LAYOUT ────────────────────────────────────────────────── -->
      <div class="row">
        <div class="col-lg-12">
          <!-- Filters -->
          <div class="row mb-0 px-3">
            <div class="col-3">
              <label class="text-dark" for="urlMapping"
                ><strong>Filters</strong></label
              >
            </div>
            <div class="col-9 d-flex justify-content-end mt-2 pr-0">
              <button
                class="btn btn-outline-secondary btn-sm btn-filter"
                (click)="onFilterChange()"
              >
                Find
              </button>
            </div>
            <!-- Location -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Location</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingLocation"
              >
                <option *ngFor="let loc of locations" [value]="loc.value">
                  {{ loc.label }}
                </option>
              </select>
            </div>

            <!-- Universe -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Universe</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingUniverse"
              >
                <option value="">All Universes</option>
                <option *ngFor="let uni of universes" [value]="uni.value">
                  {{ uni.label }}
                </option>
              </select>
            </div>

            <!-- Category -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Category</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingCategory"
              >
                <option value="">All Categories</option>
                <option *ngFor="let cat of categories" [value]="cat.value">
                  {{ cat.label }}
                </option>
              </select>
            </div>

            <!-- Issue Type -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Issue Type</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingIssueType"
              >
                <option *ngFor="let it of issueTypes" [value]="it.value">
                  {{ it.label }}
                </option>
              </select>
            </div>

            <!-- Status -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Status</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingStatus"
              >
                <option *ngFor="let st of statuses" [value]="st.value">
                  {{ st.label }}
                </option>
              </select>
            </div>

            <!-- Priority -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Priority</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingPriority"
              >
                <option *ngFor="let pr of priorities" [value]="pr.value">
                  {{ pr.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-12"> -->
      <!-- ── STAT CARDS ──────────────style="min-width: 165px -->
      <div class="row">
        <div class="col-12">
          <div
            class="row m-0 align-items-stretch flex-nowrap custom-scroll-x p-0 gap-3"
          >
            <!-- URLs Audited -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-blue me-3">
                    <i class="material-icons">article</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.63rem; letter-spacing: 0.5px"
                    >
                      <strong>URLS AUDITED</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.urlsAudited.value }}
                    </h3>
                    <div
                      class="small fw-medium"
                      [ngClass]="
                        stats.urlsAudited.up ? 'text-success' : 'text-danger'
                      "
                    >
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                      >
                        {{
                          stats.urlsAudited.up
                            ? "arrow_upward"
                            : "arrow_downward"
                        }}
                      </span>
                      {{ stats.urlsAudited.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Issues Detected -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-orange me-3">
                    <i class="material-icons">warning_amber</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.63rem; letter-spacing: 0.5px"
                    >
                      <strong>ISSUES DETECTED</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.issuesDetected.value }}
                    </h3>
                    <div
                      class="small fw-medium"
                      [ngClass]="
                        stats.issuesDetected.up ? 'text-success' : 'text-danger'
                      "
                    >
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                      >
                        {{
                          stats.issuesDetected.up
                            ? "arrow_upward"
                            : "arrow_downward"
                        }}
                      </span>
                      {{ stats.issuesDetected.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Critical Issues -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-red me-3">
                    <i class="material-icons">cancel</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.63rem; letter-spacing: 0.5px"
                    >
                      <strong>CRITICAL ISSUES</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.criticalIssues.value }}
                    </h3>
                    <div
                      class="small fw-medium"
                      [ngClass]="
                        stats.criticalIssues.up ? 'text-success' : 'text-danger'
                      "
                    >
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                      >
                        {{
                          stats.criticalIssues.up
                            ? "arrow_upward"
                            : "arrow_downward"
                        }}
                      </span>
                      {{ stats.criticalIssues.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pending Fix -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-orange me-3">
                    <i class="material-icons">pending_actions</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.63rem; letter-spacing: 0.5px"
                    >
                      <strong>PENDING FIX</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.pendingFix.value }}
                    </h3>
                    <div
                      class="small fw-medium"
                      [ngClass]="
                        stats.pendingFix.up ? 'text-success' : 'text-danger'
                      "
                    >
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                      >
                        {{
                          stats.pendingFix.up
                            ? "arrow_upward"
                            : "arrow_downward"
                        }}
                      </span>
                      {{ stats.pendingFix.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Resolved -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-green me-3">
                    <i class="material-icons">check_circle</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.63rem; letter-spacing: 0.5px"
                    >
                      <strong>RESOLVED</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.resolved.value }}
                    </h3>
                    <div
                      class="small fw-medium"
                      [ngClass]="
                        stats.resolved.up ? 'text-success' : 'text-danger'
                      "
                    >
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                      >
                        {{
                          stats.resolved.up ? "arrow_upward" : "arrow_downward"
                        }}
                      </span>
                      {{ stats.resolved.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Eligibility Health -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-purple me-3">
                    <i class="material-icons">monitor_heart</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.63rem; letter-spacing: 0.5px"
                    >
                      <strong>ELIGIBILITY HEALTH</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.eligibilityHealth.value }}%
                    </h3>
                    <div
                      class="small fw-medium"
                      [ngClass]="
                        stats.eligibilityHealth.up
                          ? 'text-success'
                          : 'text-danger'
                      "
                    >
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                      >
                        {{
                          stats.eligibilityHealth.up
                            ? "arrow_upward"
                            : "arrow_downward"
                        }}
                      </span>
                      {{ stats.eligibilityHealth.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div>
      </div> -->

      <div class="row">
        <div class="col-12 d-flex">
          <!-- ── TECHNICAL ISSUES QUEUE ─────────────────────────────────── -->
          <div class="card shadow-sm mb-4 mt-0 flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0 px-0">
              <h4 class="fw-bold fs-6 mb-3 pl-3">
                <strong>TECHNICAL ISSUES QUEUE</strong>
                <i class="fas fa-info-circle text-muted ms-1 small pl-1"></i>
              </h4>
              <!-- Tab Navigation -->
              <ul
                class="nav nav-tabs nav-tabs-custom flex-nowrap custom-scroll-x px-0 pb-4 ul-tabs-custom"
              >
                <li class="nav-item" *ngFor="let tab of tabs">
                  <a
                    class="nav-link fw-bold"
                    [class.active]="activeTab === tab.key"
                    href="javascript:void(0)"
                    (click)="setTab(tab.key)"
                  >
                    <strong>{{ tab.label }}</strong>
                    <span class="badge bg-light border text-dark ms-1">{{
                      tab.count
                    }}</span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-hover align-middle mb-0 text-sm">
                  <thead class="bg-light small text-uppercase">
                    <tr>
                      <th class="kw-url-mapping-header">
                        <strong>URL</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>PRIMARY INTENT</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>ISSUE TYPE</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>ISSUE DETAILS</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>PRIORITY</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>STATUS</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>DETECTED</strong>
                      </th>
                      <th class="pe-3 text-end kw-url-mapping-header">
                        <strong>ACTION</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let issue of filteredIssues"
                      [class.table-active]="issue.url === selectedIssue.url"
                      (click)="selectIssue(issue)"
                      style="cursor: pointer"
                    >
                      <td class="fw-medium text-primary">
                        <a href="javascript:void(0)">{{ issue.url }}</a>
                      </td>
                      <td>{{ issue.primaryIntent }}</td>
                      <td>
                        <span>
                          <i [class]="issue.issueTypeIcon" class="me-1"></i>
                          {{ issue.issueType }}
                        </span>
                      </td>
                      <td style="font-size: 0.78rem">
                        {{ issue.issueDetails }}
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill"
                          [class]="getPriorityClass(issue.priority)"
                          >{{ issue.priority }}</span
                        >
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill text-transformNone"
                          [class]="getStatusClass(issue.status)"
                        >
                          {{ issue.status }}
                        </span>
                      </td>
                      <td style="font-size: 0.78rem; white-space: nowrap">
                        {{ issue.detected }}
                      </td>
                      <td class="pe-3 text-end">
                        <a
                          href="javascript:void(0)"
                          class="text-primary text-decoration-none fw-medium"
                          style="font-size: 0.8rem"
                        >
                          {{ issue.recommendedAction }}
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Pagination -->
              <!-- <div
                class="d-flex justify-content-between align-items-center p-3 border-top bg-light"
              >
                <span class="small text-muted"
                  >Showing 1 to 8 of 156 results</span
                >
                <div class="d-flex gap-1">
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <button class="btn btn-sm btn-dark px-2">1</button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    2
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    3
                  </button>
                  <span class="px-2">...</span>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    20
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
                <select class="form-select form-select-sm w-auto">
                  <option>10 / page</option>
                </select>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-8 d-flex">
          <!-- Selected Issue Review -->
          <div class="card shadow-sm mb-4 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 d-flex justify-content-between align-items-center pb-0 pt-3 p-2"
            >
              <h4 class="fw-bold text-uppercase mb-0 pl-2 small">
                <strong>SELECTED ISSUE REVIEW</strong>
              </h4>
            </div>
            <div class="card-body pt-2 pl-2">
              <!-- Issue Type + Priority badge -->
              <div class="d-flex align-items-center mb-2 pl-2 gap-2">
                <span
                  class="badge bg-danger-light text-danger text-transformNone fw-medium"
                >
                  <i class="fas fa-exclamation-circle me-1"></i
                  >{{ selectedIssue.issueType }}
                </span>
                <span
                  class="badge bg-danger-light text-danger text-transformNone"
                  >{{ selectedIssue.priority }} Priority</span
                >
              </div>

              <!-- URL + Primary URL badge -->
              <div class="d-flex align-items-center mb-3 gap-2">
                <a
                  href="javascript:void(0)"
                  class="text-primary fw-medium pl-2"
                  style="font-size: 0.85rem"
                >
                  {{ selectedIssue.url }}
                  <i
                    class="fas fa-external-link-alt ms-1"
                    style="font-size: 0.7rem"
                  ></i>
                </a>
                <span
                  class="badge bg-success-light text-success text-transformNone"
                  >Primary URL</span
                >
              </div>

              <!-- Mapped Intent -->
              <div class="d-flex align-items-center mb-3 pl-2">
                <span class="small text-dark me-1">Mapped Intent:</span>
                <span class="small fw-medium text-dark pl-1">{{
                  selectedIssue.mappedIntent
                }}</span>
              </div>

              <!-- Detail table -->
              <div class="table-responsive custom-scroll-x">
                <table
                  class="table table-sm table-borderless small mb-3 border-top border-bottom border-info"
                >
                  <tbody>
                    <tr>
                      <td class="text-dark w-50" style="font-size: 0.78rem">
                        Issue
                      </td>
                      <td class="text-end">
                        <span
                          class="text-danger fw-medium text-transformNone"
                          style="font-size: 0.78rem"
                          >{{ selectedIssue.issue }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50" style="font-size: 0.78rem">
                        Current Status
                      </td>
                      <td class="text-end">
                        <span
                          class="badge bg-danger-light text-danger text-transformNone"
                          >{{ selectedIssue.currentStatus }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50" style="font-size: 0.78rem">
                        Expected
                      </td>
                      <td class="text-end">
                        <span
                          class="badge bg-primary-light text-primary text-transformNone"
                          >{{ selectedIssue.expected }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50" style="font-size: 0.78rem">
                        Impact
                      </td>
                      <td class="text-end">
                        <span
                          class="badge bg-danger-light text-danger text-transformNone"
                          >{{ selectedIssue.impact }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50" style="font-size: 0.78rem">
                        Indexation Status
                      </td>
                      <td class="text-end">
                        <span
                          class="badge bg-success-light text-success text-transformNone"
                          >{{ selectedIssue.indexationStatus }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50" style="font-size: 0.78rem">
                        HTTP Status
                      </td>
                      <td class="text-end">
                        <span
                          class="badge bg-success-light text-success text-transformNone"
                          style="font-size: 0.78rem"
                          >{{ selectedIssue.httpStatus }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50" style="font-size: 0.78rem">
                        Canonical Found
                      </td>
                      <td class="text-end">
                        <span
                          class="text-primary fw-medium"
                          style="font-size: 0.78rem"
                          >{{ selectedIssue.canonicalFound }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50" style="font-size: 0.78rem">
                        Discovered
                      </td>
                      <td class="text-end" style="font-size: 0.72rem">
                        {{ selectedIssue.discovered }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50" style="font-size: 0.78rem">
                        First Detected
                      </td>
                      <td class="text-end" style="font-size: 0.72rem">
                        {{ selectedIssue.firstDetected }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50" style="font-size: 0.78rem">
                        Last Checked
                      </td>
                      <td class="text-end" style="font-size: 0.72rem">
                        {{ selectedIssue.lastChecked }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50" style="font-size: 0.78rem">
                        Review Origin
                      </td>
                      <td class="text-end" style="font-size: 0.72rem">
                        {{ selectedIssue.reviewOrigin }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- AI Rationale -->
              <div class="bg-light p-2 rounded mb-0">
                <h5 class="small fw-bold text-uppercase mb-2 ai-rationale">
                  AI RATIONALE
                </h5>
                <p class="small text-muted mb-0 lh-sm">
                  {{ selectedIssue.aiRationale }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 d-flex pl-0">
          <!-- Signals Card -->
          <div class="card shadow-sm mb-4 flex-grow-1 mt-0">
            <div class="card-body p-2 custom-scroll-x">
              <!-- Signals -->
              <div
                class="d-flex justify-content-between align-items-center mb-2 pl-2"
              >
                <h4 class="small fw-bold text-uppercase mb-0 ai-rationale">
                  SIGNALS
                </h4>
                <a href="#" class="small text-decoration-none text-primary"
                  >View all signals <i class="fas fa-arrow-right"></i
                ></a>
              </div>
              <table class="table table-sm table-borderless small mb-0">
                <thead class="text-uppercase">
                  <tr>
                    <th class="head-table"><strong>SIGNAL</strong></th>
                    <th class="head-table"><strong>TO</strong></th>
                    <th class="head-table text-center">
                      <strong>STATUS</strong>
                    </th>
                    <th class="head-table text-end"><strong>DATE</strong></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let sg of signals">
                    <td
                      class="text-truncate"
                      style="max-width: 110px; font-size: 0.72rem"
                      [title]="sg.signal"
                    >
                      {{ sg.signal }}
                    </td>
                    <td style="font-size: 0.72rem text-primary">{{ sg.to }}</td>
                    <td class="text-center">
                      <span
                        class="badge rounded-pill"
                        [class]="getSignalStatusClass(sg.status)"
                        >{{ sg.status }}</span
                      >
                    </td>
                    <td
                      class="text-end"
                      style="font-size: 0.7rem; white-space: nowrap"
                    >
                      {{ sg.date }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- END col-4 -->
      </div>
      <!-- END main row -->

      <div class="row mb-4">
        <!-- <div class="col-12 d-flex">
          <div class="row row-cols-1 row-cols-md-4 g-3 mb-4"> -->
        <!-- Technical Eligibility Overview -->
        <div class="col-3">
          <div class="card shadow-sm h-100 mt-0 flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0">
              <h4 class="fw-bold text-uppercase small mb-1">
                <strong>TECHNICAL ELIGIBILITY OVERVIEW</strong>
              </h4>
            </div>
            <div class="card-body p-2 eligibility-card-body">
              <div class="d-flex flex-row align-items-center gap-3">
                <!-- Donut -->
                <div class="eligibility-donut flex-shrink-0">
                  <span class="eligibility-pct fw-bold text-success"
                    >{{ eligibilityOverview.score }}%</span
                  >
                  <span class="eligibility-label small text-muted"
                    >Healthy</span
                  >
                </div>
                <!-- Legend -->
                <div class="flex-grow-1 ml-2">
                  <div
                    class="d-flex justify-content-between align-items-center mb-2 pb-1"
                  >
                    <div class="d-flex align-items-center flex-grow-1">
                      <span class="dot dot-green me-2"></span>
                      <span class="small fw-semibold text-dark">Eligible</span>
                    </div>
                    <div class="text-end" style="width: 50px">
                      <span class="small fw-semibold text-dark">{{
                        eligibilityOverview.eligible.count
                      }}</span>
                    </div>
                    <div class="text-end" style="width: 45px">
                      <span class="small fw-semibold text-dark"
                        >{{ eligibilityOverview.eligible.pct }}%</span
                      >
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center mb-2 pb-1"
                  >
                    <div class="d-flex align-items-center flex-grow-1">
                      <span class="dot dot-orange me-2"></span>
                      <span class="small fw-semibold text-dark">At Risk</span>
                    </div>
                    <div class="text-end" style="width: 50px">
                      <span class="small fw-semibold text-dark">{{
                        eligibilityOverview.atRisk.count
                      }}</span>
                    </div>
                    <div class="text-end" style="width: 45px">
                      <span class="small fw-semibold text-dark"
                        >{{ eligibilityOverview.atRisk.pct }}%</span
                      >
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="d-flex align-items-center flex-grow-1">
                      <span class="dot dot-red me-2"></span>
                      <span class="small fw-semibold text-dark"
                        >Ineligible</span
                      >
                    </div>
                    <div class="text-end" style="width: 50px">
                      <span class="small fw-semibold text-dark">{{
                        eligibilityOverview.ineligible.count
                      }}</span>
                    </div>
                    <div class="text-end" style="width: 45px">
                      <span class="small fw-semibold text-dark"
                        >{{ eligibilityOverview.ineligible.pct }}%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end w-100 p-1 border-top mt-2">
                <a href="#" class="small text-decoration-none text-primary"
                  >View full report <i class="fas fa-arrow-right"></i
                ></a>
              </div>
            </div>
          </div>
        </div>

        <!-- Issues By Type -->
        <div class="col-3 pl-0">
          <div class="card shadow-sm h-100 mt-0">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex justify-content-between pl-2"
            >
              <h4 class="fw-bold text-uppercase small mb-1">
                <strong>ISSUES BY TYPE</strong>
              </h4>
              <a href="#" class="small text-decoration-none text-primary"
                >View all <i class="fas fa-arrow-right"></i
              ></a>
            </div>
            <div class="card-body p-0 custom-scroll-x">
              <table class="table table-sm table-borderless small mb-0">
                <thead class="text-uppercase">
                  <tr>
                    <th class="ps-3 head-table">
                      <strong>ISSUE TYPE</strong>
                    </th>
                    <th class="head-table text-center">
                      <strong>ISSUES</strong>
                    </th>
                    <th class="head-table text-center">
                      <strong>CHANGE</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ibt of issuesByType">
                    <td
                      class="ps-3 fw-medium text-truncate"
                      style="max-width: 130px"
                      [title]="ibt.type"
                    >
                      {{ ibt.type }}
                    </td>
                    <td class="text-center fw-bold">{{ ibt.issues }}</td>
                    <td class="text-center">
                      <span
                        [class]="
                          ibt.changeDir === 'up'
                            ? 'text-danger fw-medium'
                            : 'text-success fw-medium'
                        "
                      >
                        <i
                          class="fas"
                          [class]="
                            ibt.changeDir === 'up'
                              ? 'fa-arrow-up'
                              : 'fa-arrow-down'
                          "
                        ></i>
                        {{ ibt.change > 0 ? "+" : "" }}{{ ibt.change }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Top Pages by Issues -->
        <div class="col-3 pl-0">
          <div class="card shadow-sm h-100 mt-0">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex justify-content-between pl-2"
            >
              <h4 class="fw-bold text-uppercase small mb-1">
                <strong>TOP PAGES BY ISSUES</strong>
              </h4>
              <a href="#" class="small text-decoration-none text-primary"
                >View all <i class="fas fa-arrow-right"></i
              ></a>
            </div>
            <div class="card-body p-0 custom-scroll-x">
              <table class="table table-sm table-borderless small mb-0">
                <thead class="text-uppercase">
                  <tr>
                    <th class="ps-3 head-table"><strong>URL</strong></th>
                    <th class="head-table text-center">
                      <strong>ISSUES</strong>
                    </th>
                    <th class="head-table text-center">
                      <strong>HIGHEST SEVERITY</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let tp of topPagesByIssues">
                    <td
                      class="ps-3 text-primary fw-medium text-truncate"
                      style="max-width: 120px"
                      [title]="tp.url"
                    >
                      <a href="javascript:void(0)">{{ tp.url }}</a>
                    </td>
                    <td class="text-center fw-bold">{{ tp.issues }}</td>
                    <td class="text-center">
                      <span [class]="getSeverityClass(tp.severity)">{{
                        tp.severity
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Recently Resolved -->
        <div class="col-3 pl-0">
          <div class="card shadow-sm h-100 mt-0">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex justify-content-between pl-2"
            >
              <h4 class="fw-bold text-uppercase small mb-1">
                <strong>RECENTLY RESOLVED</strong>
              </h4>
              <a href="#" class="small text-decoration-none text-primary"
                >View all <i class="fas fa-arrow-right"></i
              ></a>
            </div>
            <div class="card-body p-0 custom-scroll-x">
              <table class="table table-sm table-borderless small mb-0">
                <thead class="text-uppercase">
                  <tr>
                    <th class="ps-3 head-table"><strong>ISSUE</strong></th>
                    <th class="head-table"><strong>URL</strong></th>
                    <th class="head-table text-center">
                      <strong>RESOLVED</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let rr of recentlyResolved">
                    <td
                      class="ps-3 fw-medium text-truncate"
                      style="max-width: 100px"
                      [title]="rr.issue"
                    >
                      {{ rr.issue }}
                    </td>
                    <td
                      class="text-primary text-truncate"
                      style="max-width: 100px; font-size: 0.75rem"
                      [title]="rr.url"
                    >
                      <a href="javascript:void(0)">{{ rr.url }}</a>
                    </td>
                    <td
                      class="text-center text-muted"
                      style="font-size: 0.72rem; white-space: nowrap"
                    >
                      {{ rr.resolved }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!--  -->
      </div>

      <!-- ── TECHNICAL ACTION CENTER ────────────────────────────────────── -->
      <div class="row">
        <div class="col-12">
          <div class="card shadow-sm mt-0" style="border: 1px solid #ffcdd2">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 px-3 d-flex align-items-center"
            >
              <h4 class="fw-bold text-uppercase small mb-0 me-3">
                <strong>TECHNICAL ACTION CENTER</strong>
              </h4>
              <span
                class="badge bg-success-light text-success text-transformNone"
                >1 issue selected</span
              >
            </div>
            <div class="card-body container-fluid pl-0 pr-0">
              <div class="custom-scroll-x pb-2">
                <!-- <div
                  class="d-flex align-items-stretch flex-nowrap mx-0 gap-3"
                  style="min-width: 1100px"
                > -->
                <div
                  class="row align-items-stretch flex-nowrap mx-0"
                  style="min-width: 900px"
                >
                  <div class="col-12 pt-3 d-flex">
                    <!-- SELECTED ACTION -->
                    <div class="col-auto">
                      <h6
                        class="small fw-bold text-dark mb-3 text-uppercase"
                        style="font-size: 0.7rem; letter-spacing: 0.5px"
                      >
                        <strong>SELECTED ACTION</strong>
                      </h6>
                      <p class="fw-bold text-dark text-nowrap font-size12">
                        <strong>{{ actionCenter.selectedAction }}</strong>
                      </p>
                      <div
                        class="d-flex justify-content-between align-items-center w-100 mb-1"
                      >
                        <h6
                          class="small fw-bold text-dark mb-0 text-uppercase"
                          style="font-size: 0.7rem; letter-spacing: 0.5px"
                        >
                          <strong>TARGET URL</strong>
                        </h6>
                        <span class="small fw-medium text-end">{{
                          actionCenter.targetUrl
                        }}</span>
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center w-100 mb-1"
                      >
                        <h6
                          class="small fw-bold text-dark mb-0 text-uppercase"
                          style="font-size: 0.7rem; letter-spacing: 0.5px"
                        >
                          <strong>ELEMENT</strong>
                        </h6>
                        <span class="small fw-medium text-end">{{
                          actionCenter.element
                        }}</span>
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center w-100 mb-1"
                      >
                        <h6
                          class="small fw-bold text-dark mb-0 text-uppercase"
                          style="font-size: 0.7rem; letter-spacing: 0.5px"
                        >
                          <strong>DECISION ORIGIN</strong>
                        </h6>
                        <span class="small fw-medium text-end">{{
                          actionCenter.decisionOrigin
                        }}</span>
                      </div>
                    </div>

                    <!-- CURRENT -->
                    <div class="col-auto border rounded bg-white p-3">
                      <h6
                        class="small fw-bold text-dark mb-2 text-uppercase"
                        style="font-size: 0.75rem"
                      >
                        <strong>CURRENT</strong>
                      </h6>
                      <pre
                        class="code-block mb-0"
                      ><code>{{ actionCenter.currentCode }}</code></pre>
                    </div>

                    <!-- ARROW -->
                    <div
                      class="d-flex align-items-center justify-content-center px-1"
                    >
                      <i class="fas fa-arrow-right text-muted"></i>
                    </div>

                    <!-- PROPOSED -->
                    <div
                      class="col-auto border rounded p-3"
                      style="
                        background-color: #f8fff9;
                        border-color: #e6f4ea !important;
                      "
                    >
                      <h6
                        class="small fw-bold text-dark mb-2 text-uppercase"
                        style="font-size: 0.75rem"
                      >
                        <strong>PROPOSED</strong>
                      </h6>
                      <pre
                        class="code-block mb-0"
                      ><code>{{ actionCenter.proposedCode }}</code></pre>
                    </div>
                  </div>
                </div>
                <div
                  class="row align-items-stretch flex-nowrap mx-0"
                  style="min-width: 900px"
                >
                  <div class="col-12 pt-3 d-flex">
                    <!-- AI RECOMMENDATION -->
                    <div
                      class="col border-start ps-4"
                      style="width: 280px"
                    >
                      <h6
                        class="small fw-bold text-primary mb-2 text-uppercase"
                        style="font-size: 0.75rem; font-weight: bold"
                      >
                        AI RECOMMENDATION
                      </h6>
                      <p
                        class="small text-muted mb-2 lh-sm"
                        style="font-size: 0.8rem"
                      >
                        {{ actionCenter.aiRecommendation }}
                      </p>
                      <a
                        href="javascript:void(0)"
                        class="small text-primary text-decoration-none fw-medium"
                      >
                        View full rationale
                        <i class="fas fa-arrow-right ms-1"></i>
                      </a>
                    </div>

                    <!-- Confidence / Risk / Mode -->
                    <div class="col border-start ps-4 ms-2 d-flex gap-4">
                      <div class="text-center pr-2">
                        <h6
                          class="small fw-bold text-dark mb-3 text-uppercase"
                          style="
                            font-size: 0.7rem;
                            letter-spacing: 0.5px;
                            font-weight: bold;
                          "
                        >
                          AI CONFIDENCE
                        </h6>
                        <div class="progress-circle mx-auto" data-perc="92">
                          <span class="text-success fw-bold fs-5"
                            >{{ actionCenter.aiConfidence }}%</span
                          >
                          <span
                            class="small text-muted"
                            style="font-size: 0.65rem"
                            >High</span
                          >
                        </div>
                      </div>
                      <div class="text-center pr-2">
                        <h6
                          class="small fw-bold text-dark mb-3 text-uppercase"
                          style="
                            font-size: 0.7rem;
                            letter-spacing: 0.5px;
                            font-weight: bold;
                          "
                        >
                          RISK LEVEL
                        </h6>
                        <span
                          class="badge bg-warning-light text-warning px-3 py-1 mt-2"
                          >{{ actionCenter.riskLevel }}</span
                        >
                      </div>
                      <div class="text-center pr-2">
                        <h6
                          class="small fw-bold text-dark mb-3 text-uppercase"
                          style="
                            font-size: 0.7rem;
                            letter-spacing: 0.5px;
                            font-weight: bold;
                          "
                        >
                          EXECUTION MODE
                        </h6>
                        <div
                          class="badge bg-warning-light text-warning text-wrap mx-auto py-2 px-3 mt-1"
                          style="width: 120px; line-height: 1.3"
                        >
                          {{ actionCenter.executionMode }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Action Buttons -->
                <div
                  class="d-flex gap-3 justify-content-between mt-4 custom-scroll-x pb-2 flex-nowrap"
                  style="min-width: 100%"
                >
                  <div class="d-flex gap-2 flex-nowrap m-auto">
                    <button
                      class="btn btn-success fw-medium flex-fill btn-desicion-mapping"
                      (click)="approveAction()"
                      [disabled]="saving"
                    >
                      <i class="fas fa-check me-2"></i> Approve &amp; Implement
                    </button>
                    <button
                      class="btn btn-outline-secondary fw-medium flex-fill btn-desicion-mapping"
                    >
                      <i class="fas fa-pencil-alt me-2"></i> Edit Action
                    </button>
                    <button
                      class="btn btn-outline-primary border border-primary fw-medium flex-fill btn-desicion-mapping"
                      style="color: #a855f7; background-color: white"
                    >
                      <i class="fas fa-magic me-2"></i> Ask AI to Reconsider
                    </button>
                    <button
                      class="btn btn-outline-danger border border-danger fw-medium flex-fill text-danger bg-white btn-desicion-mapping"
                      (click)="rejectAction()"
                      [disabled]="saving"
                    >
                      <i class="fas fa-times me-2 text-danger"></i> Reject
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary fw-medium btn-desicion-mapping d-flex justify-content-between align-items-center bg-white dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      <span
                        ><i class="fas fa-paper-plane me-2 text-primary"></i>
                        Create Signal</span
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary fw-medium btn-desicion-mapping d-flex justify-content-between align-items-center bg-white dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      <span
                        ><i class="fas fa-ellipsis-h me-2"></i> More
                        Actions</span
                      >
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer note -->
        <!-- <div class="mt-3 text-muted small d-flex align-items-center">
        <i class="fas fa-info-circle me-2 pr-2"></i>
        Technical QA verifies and fixes technical issues that affect SEO
        performance. For content or link-related actions, signals are sent to
        the appropriate specialist.
      </div> -->
      </div>

      <!-- Loading spinner -->
      <div
        *ngIf="loading"
        class="d-flex justify-content-center align-items-center"
        style="min-height: 400px"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>
